module.exports = __webpack_public_path__ + "static/media/landing_0006_f.438ed75d.jpg";